import script from "./HrAvatar.vue?vue&type=script&setup=true&lang=js"
export * from "./HrAvatar.vue?vue&type=script&setup=true&lang=js"

import "./HrAvatar.vue?vue&type=style&index=0&id=ecbfa6ea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ecbfa6ea"]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QImg,QAvatar});
